// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2754":"b62f504db87acc0e","6263":"ded954ef500102ec"}[chunkId] + ".js";
};